import { useQuery } from "@tanstack/react-query";

import { digitalHumanService, type DhPriceVariants } from "../api/digitalHumanService";

/**
 * dh.render 规格档表(生动版固定 168/秒,其余档按执行口径;见 `dhVariantOf` 头注)。
 *
 * ★拿不到 → null,调用方不出数字、不开单(不兜前端映射:那正是 Z2 追加要去掉的东西)。
 * ★provider 是部署期配置,会话内不变 —— 缓存久一点,别每次渲染都问。
 */
export function useDhPriceVariants(): DhPriceVariants | null {
  const q = useQuery({
    queryKey: ["dh", "price-variants"],
    queryFn: () => digitalHumanService.getPriceVariants(),
    staleTime: 10 * 60_000,
    retry: 1,
  });
  return q.data ?? null;
}
